import { Action, createAction, props } from '@ngrx/store';

import { ScannedCodeType } from 'app/features/scan-flow/models';

export const addScannedCode = createAction(
    '[ScannedCodes] Add Scanned Code',
    props<{ token: string; code: string }>(),
);

export const scanNewCode = createAction(
    '[ScannedCodes] Scan New Code',
    props<{
        allowedCodeTypes: ScannedCodeType[];
        onScanFinishedAction: Action | undefined;
        token: string;
    }>(),
);

export const resetScannedCode = createAction('[ScannedCodes] Reset Scanned Code', props<{ token: string }>());
